<!--
 * @Description: 登录页面
 * @Author: laoliu，wanqian sunhuihong
 * @Date: 2021-01-17 22:43:52
-->
<template>
  <div class="body">
    <div class="main-body">
      <div class="header">
        <el-image class="sys-logo" :src="instLogoPath" fit="contain"></el-image>

        <span style="margin-right:8px;">{{title}}</span>
        <span class="header-children-title">智慧陪护管理平台</span>
        <span v-if="curInstitution.name" class="header-children-title">|</span>
        <span v-if="curInstitution.name" class="header-children-title">{{curInstitution.name}}</span>
      </div>
      <div style="width: 100%; max-height: 520px; overflow: hidden;">
        <el-carousel v-if="advertList[0] && advertList.length > 1" indicator-position :interval="4000" height="520px" style="overflow: hidden;">
          <el-carousel-item v-for="(item, index) in advertList" :key="index">
            <el-image :src="photoPath(item)" style="width: 100%;" fit="contain"></el-image>
          </el-carousel-item>
        </el-carousel>
        <el-image v-else-if="advertList.length == 1" :src="photoPath(advertList[0])" style="width: 100%;" fit="contain"></el-image>
        <el-image v-else :src="adverPath" style="width: 100%;" fit="contain"></el-image>
      </div>
    </div>
    <div class="right-body">
      <div class="login-body">
        <div class="bk-welcome">
          <el-image v-if="curInstitution.name" class="login-logo" :src="logoPath" fit="cover"></el-image>
          <span class="login-welcome">欢迎登录！</span>
        </div>
        <div class="bk-login-modes">
          <div class="login-mode-item bk-passwd-login mouse-pointer" @click="loginMode = 0">
            <div :class="loginMode == 0 ? 'login-mode-item-title login-mode-item-title-select' 
              : 'login-mode-item-title login-mode-item-title-diselect'">
              密码登录
            </div>
            <div :class="loginMode == 0 ? 'line line-select' : 'line line-diselect'"></div>
          </div>
          <div class="login-mode-item bk-passwd-free-login mouse-pointer" style="margin-left: 47px;" 
            @click="loginMode = 1">
            <div :class="loginMode == 1 ? 'login-mode-item-title login-mode-item-title-select' 
              : 'login-mode-item-title login-mode-item-title-diselect'">
              免密登录
            </div>
            <div :class="loginMode == 1 ? 'line line-select' : 'line line-diselect'"></div>
          </div>
        </div>
        <el-form v-show="loginMode == 0" ref="passwdForm" :model="passwdForm" :rules="passwdFormRules" 
          label-width="0px">
          <el-form-item  prop="username" style="margin-top: 22px;">
            <el-input class="input-radius" :placeholder="passwdLoginMode == 0 ? '请输入账号' : '请输入手机号'" 
              v-model="passwdForm.username" @keyup.enter.native="handlePasswdLogin('passwdForm')">
            </el-input>
          </el-form-item>
          <el-form-item prop="password" style="margin: 22px 0 15px 0;">
            <el-input class="input-radius" placeholder="请输入密码" v-model="passwdForm.password" 
              :type="typePassswd" @keyup.enter.native="handlePasswdLogin('passwdForm')">
              <i slot="suffix" style="margin-right: 5px" :class="classPassswd" @click="changePassswdVisible"></i>
            </el-input>
          </el-form-item>
          <div class="btn-passwd-login mouse-pointer" @click="handlePasswdLoginModeChange">
            {{passwdLoginMode == 0 ? '手机号登录' : '账号登录'}}
          </div>
          <el-form-item style="margin: 18px 0 2px 0;">
            <el-checkbox style="width: 100%; text-align: left" 
              label="7天免登录" v-model="passwdForm['remember-me']">
            </el-checkbox>
          </el-form-item>
          <el-form-item>
            <el-button round style="width: 100%" type="primary" @click="handlePasswdLogin('passwdForm')">
              登 录
            </el-button>
          </el-form-item>
        </el-form>
        <el-form v-show="loginMode == 1" ref="passwdFreeForm" class="passwd-free-form" :model="passwdFreeForm" 
          :rules="passwdFreeFormRules" label-width="0px">
          <el-form-item  prop="username" style="margin-top: 22px;">
            <div class="bk-item bk-telephone">
              <span class="span-prepend">+86</span>
              <div class="line"></div>
              <el-input placeholder="请输入手机号" v-model="passwdFreeForm.username"
                @keyup.enter.native="handlePasswdFreeLogin('passwdFreeForm')">
              </el-input>
            </div>
          </el-form-item>
          <el-form-item prop="password" style="margin: 22px 0;">
            <div class="bk-item bk-code">
              <el-input placeholder="请输入6位数字验证码" v-model="passwdFreeForm.password" :maxlength="6"
                @keyup.enter.native="handlePasswdFreeLogin('passwdFreeForm')" @input="inputCode">
              </el-input>
              <el-button type="text" class="btn-get-code" @click="handleSmsCodeBtnClick">{{smsCodeBtn.codeText}}</el-button>
            </div>
          </el-form-item>
          <el-form-item style="margin-top: 79px;">
            <el-button round style="width: 100%" type="primary" @click="handlePasswdFreeLogin('passwdFreeForm')">
              登 录
            </el-button>
          </el-form-item>
        </el-form>
      </div>
      <slider-vcode-dialog :visible="showSliderDlg" @close-dialog="handleCloseSliderDialog"/>
    </div>
    <div class="current-version">
      <span>版权所有 版本V{{version}}</span>
    </div>
  </div>
</template>

<script>
import Constant from '@/global/Constant.js'

export default {
  name: 'Login',
  data() {
    let validateUsername = (_rule, value, callback) => {
			if (!this.passwdForm.username || this.passwdForm.username.length == 0 
        || this.passwdForm.username.trim().length == 0) {
        let error = this.passwdLoginMode == 0 ? '请输入账号' : '请输入手机号';
				callback(new Error(error));
			} else {
        if (this.passwdLoginMode == 1 && !this.commonUtil.validateMobile(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
			}
    };

    let validateTelephone = (_rule, value, callback) => {
			if (!this.passwdFreeForm.username || this.passwdFreeForm.username.length == 0 
        || this.passwdFreeForm.username.trim().length == 0) {
				callback(new Error('请输入手机号'));
			} else if (!this.commonUtil.validateMobile(value)) {
          callback(new Error('请输入正确的手机号'));
        } else {
          callback();
        }
    };

    let validateCode = (_rule, _value, callback) => {
			if (!this.passwdFreeForm.password || this.passwdFreeForm.password.length == 0 
        || this.passwdFreeForm.password.trim().length == 0 || this.passwdFreeForm.password.length != 6 
        || this.passwdFreeForm.password.trim().length != 6) {
				callback(new Error('请输入6位数字验证码'));
			} else {
        callback();
      }
    };

    return {
      version: '',//项目版本号
      curInstitution: {},
      passwdForm: {
        'username': '',
        'password': '',
        'imgVcode': '',
        'remember-me': false    //这是后端系统默认的名称，不能改变
      },
      passwdFormRules: {
        username: [{required: true, validator: validateUsername, trigger: 'blur'}],
        password: [{required: true, message: '请输入密码', trigger: 'blur'}]
      },
      typePassswd: 'password',
      classPassswd: 'el-icon-close-eye',
      loginMode: 0,//0：密码登录，1：免密登录
      passwdLoginMode: 0,//0:账号登录，1：手机号登录
      passwdFreeForm: {
        'username': '',
        'password': '',
        'imgVcode': '',
      },
      passwdFreeFormRules: {
        username: [{required: true, validator: validateTelephone, trigger: 'blur'}],
        password: [{required: true, validator: validateCode, trigger: 'blur'}]
      },
      //验证码按钮
			smsCodeBtn: {
			    codeTime: 60,
			    codeText: "获取验证码",
			    codeStatus: true
			},
      codeInterval: null,

      showSliderDlg: false,

      advertList: [],

      title: '星护云',
      instLogoPath: require('@/assets/login/icon-login-jtyhlogo.png'),
      adverPath: require('@/assets/login/img-login-enpty.png'),
    }
  },

  computed: {
    logoPath: function () {  
      let path = this.curInstitution.logoBase64;
      return (!path) ? require('@/assets/login/icon-login-defaultlogo2.png') : path;
    },

    photoPath() {
			return function(photo){
				return (photo) ? this.commonUtil.fillUrlArgments(this.commonUrl.URL_DOWNLOAD_FILE, photo)
					: require("@/assets/syscfg/img-syscfg-upload.png");
			}
		}
  },

  methods: {
    //通过唯一标识获取指定机构基本信息
    getInstitutionInfo() {
      let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
      let identifier = sessionStorage.getItem(Constant.SESSION_IDENTIFIER);
      if (!identifier) return;
      
      let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_INSTITUTION_BY_IDENTIFIER, adminType, identifier);
      this.appAxios("GET", url).then(result => {
        if (result != null) {
          this.curInstitution = result.data;
        }
      });
    },

    changePassswdVisible() {
      //点击图标是密码隐藏或显示
      this.typePassswd = (this.typePassswd == "text") ? "password" : "text";
      this.classPassswd = (this.typePassswd == "text") ? "el-icon-open-eye" : "el-icon-close-eye";
    },

    handlePasswdLoginModeChange() {
      this.passwdLoginMode = !this.passwdLoginMode;
      this.$refs.passwdForm.validateField('username');
    },

    inputCode() {
      this.passwdFreeForm.password = this.commonUtil.filterDigitals(this.passwdFreeForm.password);
    },

    handleSmsCodeBtnClick() {
      if (!this.smsCodeBtn.codeStatus) {return;}
      this.$refs.passwdFreeForm.validateField('username');
      if (!this.passwdFreeForm.username || !this.commonUtil.validateMobile(this.passwdFreeForm.username)) {
        return;
      }
      this.showSliderDialog();
    },

    handlePasswdLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.showSliderDialog();
      });
    },

    handlePasswdFreeLogin(formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return false;
        this.processLogin();
      });
    },

    showSliderDialog() {
      this.showSliderDlg = true;
    },

    /**
     * succ: true/false = 验证成功/取消验证（点X关闭了对话框）
     * imgVcode: 验证码值，succ=true时有效
     */
    handleCloseSliderDialog(succ, imgVcode) {
      this.showSliderDlg = false;
      if (this.loginMode == 0) {
        this.passwdForm.imgVcode = imgVcode;
      } else {
        this.passwdFreeForm.imgVcode = imgVcode;
      }
      if (!succ) {return;}
      if (this.loginMode == 0) {
        this.processLogin();
      } else {
        this.queryCode(imgVcode);
      }
    },

    queryCode(imgVcode) {
      if (!this.smsCodeBtn.codeStatus) return;

      let url = this.commonUtil.fillUrlArgments(this.commonUrl.URL_COMMON_SM_VCODE, 'login');
      let param = { mobile: this.passwdFreeForm.username, 'imageVcode': imgVcode };
      let requestData = {
          method: 'POST',
          url: url,
          contentType: this.commonConst.CNTYPE_URLENCODED,
          param: param
      };
      this.vueRequest(requestData).then(result => {
        if (!result) return;
        this.setSmsCodeInterval();
      });
    },

    setSmsCodeInterval() {
      this.smsCodeBtn.codeStatus = false;
      this.codeInterval = setInterval(() => {
        let smsCodetime = this.smsCodeBtn.codeTime;
        smsCodetime--;
        this.smsCodeBtn.codeTime = smsCodetime;
        this.smsCodeBtn.codeText = '倒计时' + smsCodetime + "s";
        if (smsCodetime < 1) {
          clearInterval(this.codeInterval);
          this.smsCodeBtn.codeText = "重新获取";
          this.smsCodeBtn.codeTime = 60;
          this.smsCodeBtn.codeStatus = true;
        } else {
          this.smsCodeBtn.codeStatus = false;
        }
      }, 1000);
    },

    processLogin() {
        let adminType = sessionStorage.getItem(Constant.SESSION_ADMIN_TYPE);
        let instId = (this.curInstitution.id) ? this.curInstitution.id : 0;
        let paramForm = this.loginMode == 0 ? JSON.parse(JSON.stringify(this.passwdForm)) 
          : JSON.parse(JSON.stringify(this.passwdFreeForm));
        sessionStorage.removeItem('showNoReadNotify');
        paramForm.username = this.buildUserNameOfSubmitParam(paramForm.username, adminType, instId);
        // 加密
        let [header, esParam] = this.encryptionUtil.encryptParamList(paramForm, ['password'],
          Constant.ENCRYPTION_KEY_NAME, Constant.ENCRYPTION_KEY);
        let requestData = {
          method: 'POST',
          url: Constant.URL_LOGIN,
          param: esParam,
          header: header,
          contentType: this.commonConst.CNTYPE_FORM_DATA,
        };
        this.vueRequest(requestData).then(data => {
          if (data != null) {
            let result = data.data;
            sessionStorage.setItem('showNoReadNotify', true);
            this.$router.push({path: result.targetPage})
          }
        })
    },

    // 登录的username组合规则
    // 1、账号+密码登录
    // 超管/主管：passwd+gloab+用户名$$0
    // 机管：passwd+inst+用户名$$机构Id
    // 医管：passwd+hsp+用户名$$医院Id
    // 2、手机号+密码登录
    // 超管/主管：mobile+global+用户名   
    // 机管：mobile+inst+用户名$$机构Id
    // 机管：mobile+hsp+用户名$$医院Id
    // 3、手机号+验证码登录
    // 超管/主管：vcode+global+用户名   
    // 机管：vcode+inst+用户名$$机构Id
    // 机管：vcode+hsp+用户名$$医院Id
    buildUserNameOfSubmitParam(username, adminType, instId) {
      let rebuildUsername = "";
      let prefix = "";
      if (this.loginMode == 0 && this.passwdLoginMode == 0) {
        prefix = this.commonConst.LOGIN_PREFIX_PASSWD;
      } else if (this.loginMode == 0 && this.passwdLoginMode == 1) {
        prefix = this.commonConst.LOIGN_PREFIX_MOBILE;
      } else if (this.loginMode == 1) {
        prefix = this.commonConst.LOIGN_PREFIX_VERIFY_CODE;
      }
      rebuildUsername = prefix + adminType + '+' + username;
      if ((this.loginMode == 0 && this.passwdLoginMode == 0) 
        || (instId && (this.loginMode == 0 && this.passwdLoginMode == 1 || this.loginMode == 1))) {
        rebuildUsername = rebuildUsername + "$$" + instId;
      }
      return rebuildUsername;
    },

    getAdvertList(type, institutionId) {
      return new Promise((resolve, _reject) => {
        let url = this.commonUtil.fillUrlArgments(Constant.URL_GET_ADVERT_PICTURE, type, institutionId);
        this.appAxios("GET", url).then(result => {
          if (result != null) {
            this.advertList = Array.from(result.data || [], item => item.picPath);
            resolve()
          }
        });
      })
    }
  },

  async mounted() {
    this.$nextTick(() => {
      if (process.env.NODE_ENV == 'sdjk' || process.env.NODE_ENV == 'sdjktest') {
        document.title = '悠心陪护后台';
        this.title = '悠心陪护';
        this.instLogoPath = require('@/assets/login/icon-login-sdjklogo.png');
        this.adverPath = require('@/assets/login/img-login-sdjk-enpty.png');
      } else {
        document.title = '星护云服务平台';
        this.title = '星护云';
        this.instLogoPath = require('@/assets/login/icon-login-jtyhlogo.png');
        this.adverPath = require('@/assets/login/img-login-enpty.png');
      }
    });

    let adminType = this.$route.params.adminType ? this.$route.params.adminType : 'global';
    let identifier = this.$route.params.identifier ? this.$route.params.identifier : '';
    sessionStorage.setItem(Constant.SESSION_ADMIN_TYPE, adminType);
    sessionStorage.setItem(Constant.SESSION_IDENTIFIER, identifier);
    let type = (adminType == 'inst') ? 2 : 1;
    let institutionId = this.$route.params.identifier ? this.$route.params.identifier : 0;

    
    let {version} = require("../../../package.json");
    this.version = version;
    this.getInstitutionInfo();
    await this.getAdvertList(type, institutionId)
  },

  destroyed() {
    clearInterval(this.codeInterval);
    this.smsCodeBtn.codeText = "获取验证码";
    this.smsCodeBtn.codeTime = 60;
    this.smsCodeBtn.codeStatus = true;
  },
}
</script>

<style scoped>
.body {
  margin: 0;
  width: 100%;
  text-align: left;
  border-top: 0px solid blue;
}

.main-body {
  float: left;
  width: 70%;
  min-height: 810px;
  /* background: right repeat-y url('../../assets/login/img-login-shadow.png'); */
  border-top: 0px solid red;
}

.header {
  margin: 25px 0 28px 0;
  width: 100%;
  vertical-align: middle;
  font-size: 28px;
  font-weight: 500;
  border-top: 0px solid green;
  border-bottom: 0px solid green;
}

.header-children-title {
  font-size:20px;
  color: #333333;
  font-weight: 400;
}

.sys-logo {
  margin: 0 15px 0 40px;
  vertical-align: middle;
  width: 47px;
  height: 47px;
}

.right-body {
  float: left;
  width: 30%;
  border-top: 0px solid red;
}

.login-body {
  margin: 70px auto;
  width: 280px;
  min-height: 400px;
  text-align: center;
  border: 0px solid red;
}

.bk-welcome {
  padding-top: 30px;
  display: flex;
  align-items: center;
}

.login-welcome {
  font-size: 26px;
  font-weight: 400;
  text-align: left;
  color: #000000;
}

.login-logo {
  margin-right: 24px;
  width: 60px;
  height: 60px;
  border-radius: 50%;
}

.bk-login-modes {
  margin: 49px 0 25px 0;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.login-mode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.login-mode-item-title {
  font-size: 16px;
  line-height: 22px;
  font-weight: 500;
}

.login-mode-item-title-select {
  color: #3D7EF4;
}

.login-mode-item-title-diselect {
  color: #686868;
}

.login-mode-item .line {
  margin-top: 4px;
  width: 32px;
  height: 3px;
  border-radius: 3px;
}

.login-mode-item .line-select {
  background: #3D7EF4;
}

.login-mode-item .line-diselect {
  background: white;
}

.input-radius /deep/ .el-input__inner{ 
  height: 42px;
  border-radius: 20px;
}

.pt-images-verification {
	width: 640px;
	margin: 0 auto;
}

.btn-passwd-login {
  text-align: right;
  font-size: 13px;
  color: #3D7EF4;
  line-height: 18px;
}

.passwd-free-form .bk-item {
  padding: 16px 12px;
  height: 44px;
  border-radius: 20px;
  border: 1px solid #DCDFE6;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}

.bk-telephone .span-prepend {
  font-size: 13px;
  color: #000000;
}

.bk-telephone .line {
  margin-left: 15px;
  width: 2px;
  height: 19px;
  background-color: #DCDFE6;
}

.bk-telephone /deep/ .el-input__inner { 
  border: 0;
}

.bk-code /deep/ .el-input__inner {
  border: 0;
}

.btn-get-code {
  font-size: 14px;
  color: #3D7EF4;
  font-weight: 400;
}

.current-version {
  font-size: 13px;
  font-weight: 400;
  color: #9A9A9A;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/login/Login.vue